import React, { useContext, useEffect, useRef, useState } from 'react'
import styles from './styles.module.css'
import { StudentsContext } from '../../../utils/context';
import Table from '../../../components/Table';
import Button from '../../../components/Button';
import { BiTrash } from 'react-icons/bi';
import PortfolioModal from './extraModal/PortfolioModal'
import { useDispatch } from 'react-redux';
import { createStudentPortfolioItem } from '../../../actions/students/other';


export default function Portfolio() {

  const dispatch = useDispatch()

  const { allForms, addMode, studentTabData, updateInitialValues, trackDeletion, studentId } = useContext(StudentsContext)

  const { values, setFieldValue, setValues } = allForms

  const { portfolio: portfolioData } = studentTabData || {}

  const lastSyncedRef = useRef(null)

  const [selectedItem, setSelectedItem] = useState(null)

  useEffect(() => {
    const dataJson = JSON.stringify(portfolioData)
    if (!addMode && portfolioData && lastSyncedRef.current !== dataJson) {
      lastSyncedRef.current = dataJson
      setValues(prev => ({ ...prev, portfolio: [...portfolioData] }))
      if (updateInitialValues) {
        updateInitialValues('portfolio', portfolioData)
      }
    }
  }, [portfolioData, addMode, setValues, updateInitialValues])

  const openModal = (data) => () => setSelectedItem(data || {})
  const closeModal = () => setSelectedItem(null)

  const handleSaveItem = (itemData) => {
    if (selectedItem === 'add' || !itemData.xp_key) {
      const newItem = { ...itemData }
      setFieldValue('portfolio', [...(values.portfolio || []), newItem])
      dispatch(createStudentPortfolioItem(studentId, { ...itemData, year: itemData.xp_key }))
    } else {
      const updated = (values.portfolio || []).map(item =>
        item.xp_key === itemData.xp_key ? itemData : item
      )
      setFieldValue('portfolio', updated)
    }
    closeModal()
  }

  const handleDeleteItem = (xp_key) => {
    if (!String(xp_key).startsWith('new_')) {
      trackDeletion('portfolio', xp_key)
    }
    setFieldValue('portfolio', (values.portfolio || []).filter(item => item.xp_key !== xp_key))
  }

  const renderRow = (item) => {
    const { xp_key, year_name, group_name } = item
    return (
      <tr key={xp_key} onClick={openModal(item)}>
        <td>{year_name || ''}</td>
        <td>{group_name || ''}</td>
        <td>
          <i className={styles.trash} onClick={(e) => { e.stopPropagation(); handleDeleteItem(xp_key) }}>
            <BiTrash />
          </i>
        </td>
      </tr>
    )
  }

  return (
    <div className={styles.tabWrapper}>
      {selectedItem !== null &&
        <PortfolioModal
          closeModal={closeModal}
          data={selectedItem === 'add' ? {} : selectedItem}
          addMode={selectedItem === 'add'}
          onSave={handleSaveItem}
        />
      }
      <div className={styles.qualificationForm}>
        <Table className={styles.table}>
          <thead>
            <tr>
              <th>Год</th>
              <th>Класс</th>
              <th>Удалить</th>
            </tr>
          </thead>
          <tbody>
            {values.portfolio?.map(renderRow)}
          </tbody>
        </Table>
        <br />
        <Button onClick={openModal('add')}>Добавить</Button>
      </div>
    </div>
  )
}

